// Add your JS customizations here
jQuery(document).ready(function($) {

	if ($('.page-template-home').length > 0) { } else {
		$('#main-nav').addClass('other_page');
	};

	var mainNavHeight = $('#main-nav').outerHeight(true);
	//var mainNavHeightScrolled = '';

	$(window).on('scroll', function() {
		if ($(this).scrollTop() > mainNavHeight) {
    		$('#main-nav').addClass('scrolled');
    		$('#mobile_nav').addClass('scrolled');
    	} else {
    		$('#main-nav').removeClass('scrolled');
    		$('#mobile_nav').removeClass('scrolled');
    	}
	});

	$(window).on('load', function() {
		if ($(this).scrollTop() > mainNavHeight) {
    		$('#main-nav').addClass('scrolled');
    		$('#mobile_nav').addClass('scrolled');
    	} else {
    		$('#main-nav').removeClass('scrolled');
    		$('#mobile_nav').removeClass('scrolled');
    	}
	});

	function muteAudio() {

	    var audioStatus = $("#vi-video-1-container").attr('data-audio-volume');

		if (audioStatus == 0) {
		  	// Mute the audio
		  	$('#vi-video-1-container').attr('data-audio-volume', 1);
		  	$("#vi-banner-video").vimeo("setVolume", 1);
		 	$(".audio-control.js-audio-control").removeClass('muted').addClass('unmuted');
		}
		else if (audioStatus == 1){
		  	// Play the audio
		 	$('#vi-video-1-container').attr('data-audio-volume', 0);
		  	$("#vi-banner-video").vimeo("setVolume", 0);
		  	$(".audio-control.js-audio-control").removeClass('unmuted').addClass('muted');
		}
	}

	function playVideo() {
	    // var videoId = el.data('video');
	    // var video = document.getElementById(videoId);
	    var videoStatus = $("#vi-video-1-container").attr('data-video-is-playing');
	     
	    if (videoStatus == 'true') {
	        // Pause the video
	       	console.log('trigger to false');
	        $('#vi-banner-video').vimeo('pause');
	        $('#vi-video-1-container').attr('data-video-is-playing', false);
	    }
	    else if (videoStatus == 'false'){
	        // Play the video
	        console.log('trigger to true');
	        $('#vi-banner-video').vimeo('play');
	        $('#vi-video-1-container').attr('data-video-is-playing', true);
	    }
	}

	$('.hamburger').click(function(event) {
		event.preventDefault();
		$('.hamburger').toggleClass('is-active');
		$('#main-nav').toggleClass('nav_open');
		$('#mobile_nav').toggleClass('nav_open');
		$('#jba_menu').toggleClass('show');
		$('body').toggleClass('modal-open');
		$('.sub_menu').removeClass('show');
	});
	
	$('.close_sub').click(function(event) {
		event.preventDefault();
		var target = $(this).attr('href');
		$(target).removeClass('show');
	});

	$('#mobile_menu .hasSub a').click(function(event) {
		event.preventDefault();
		var target = $(this).attr('href');
		$(target).addClass('show');
	});

	if ($('.page-template-home').length > 0) {

		if ($(window).width() > 992) {
			new WOW().init();
		};

		$('.js-audio-control').click(function(event) {
			event.preventDefault();
			muteAudio($(this));
			$(this).toggleClass('audio_on');
		});

		// initial setup
	    // - audio muted/unmuted 
	    var isAudioMuted = true;
	    var isVideoAutoplay = true;

	    if ($('.vimeo-wrapper').length > 0) {
		    if ( isVideoAutoplay === true ){
		      	$('#vi-video-1-container').attr('data-video-is-playing', true);
		      	$('#vi-banner-video').vimeo('play');
		 
		    } else {
		      	$('#vi-video-1-container').attr('data-video-is-playing', false);
		      	$('#vi-banner-video').vimeo('pause');
		    }

		    if ( isAudioMuted === true ){
		     	$('#vi-video-1-container').attr('data-audio-volume', 0);
		      	$("#vi-banner-video").vimeo("setVolume", 0);
		      	$(".audio-control.js-audio-control").removeClass('unmuted').addClass('muted');
		    } else {
		      	$('#vi-video-1-container').attr('data-audio-volume', 1);
		      	$("#vi-banner-video").vimeo("setVolume", 1);
		    }
		

		    $(window).scroll(function() {

			    var scroll = $(window).scrollTop();

			    var target = $('#vi-video-1-container').outerHeight();
				//console.log('scroll',scroll);
			    if (scroll >= (target)){
				  	$('#vi-banner-video').vimeo('pause');		        
				} else {
				  	$('#vi-banner-video').vimeo('play');
				}

			});

	  	};

		

		var introductionPadding = parseInt($('#introduction').css('padding-top'));
		var introductionTitle = $('#introduction h1').outerHeight(true);
		var introductionST = introductionPadding + introductionTitle;

		$('#introduction_highlight').css('top',introductionST);

		var solutionsPadding = parseInt($('#solutions_content').css('padding-top'));
		var solutionsTitle = $('#solutions_content h2').outerHeight(true);
		var candidatesTitle = $('#solutions_candidates h2').outerHeight(true);
		var combinedST = solutionsTitle + solutionsPadding;
		var combinedCA = solutionsTitle + solutionsPadding + candidatesTitle;
		
		if ($(window).width() > 992) {
			//$('#solutions_content_text p').css('height',candidatesTitle);
			$('#solutions_candidates').css('padding-top',combinedST);
			$('#solutions_candidates_link').css('padding-top',combinedCA);
		};

		var marketsPadding = parseInt($('#markets').css('padding-top'));
		var marketsTitle = $('#markets_content h2').outerHeight(true);
		var marketsST = marketsPadding + marketsTitle;

		if ($(window).width() > 992) {

			$('#markets_selector').css('top',marketsST);

		}

		var joinPadding = parseInt($('#join').css('padding-top'));
		var joinTitle = $('#join h2').outerHeight(true);
		var joinST = joinPadding + joinTitle;

		if ($(window).width() > 992) {
			$('#join_highlight').css('top',joinST);
		}

		$(window).on('resize', function () {
			var introductionPaddingResize = parseInt($('#introduction').css('padding-top'));
			var introductionTitleResize = $('#introduction h1').outerHeight(true);
			var introductionSTResize = introductionPaddingResize + introductionTitleResize;

			if ($(window).width() > 992) {

				$('#introduction_highlight').css('top',introductionSTResize);
			}


			var solutionsPaddingResize = parseInt($('#solutions_content').css('padding-top'));
			var solutionsTitleResize = $('#solutions_content h2').outerHeight(true);
			var candidatesTitleResize = $('#solutions_candidates h2').outerHeight(true);
			var combinedSTResize = solutionsTitleResize + solutionsPaddingResize;
			var combinedCAResize = solutionsTitleResize + solutionsPaddingResize + candidatesTitleResize;
			if ($(window).width() > 992) {
				$('#solutions_content_text p').css('height',candidatesTitleResize);
				$('#solutions_candidates').css('padding-top',combinedSTResize);
				$('#solutions_candidates_link').css('padding-top',combinedCAResize);
			}

			var marketsPaddingResize = parseInt($('#markets').css('padding-top'));
			var marketsTitleResize = $('#markets_content h2').outerHeight(true);
			var marketsSTResize = marketsPaddingResize + marketsTitleResize;
			if ($(window).width() > 992) {
				$('#markets_selector').css('top',marketsSTResize);
			}

			var joinPaddingResize = parseInt($('#join').css('padding-top'));
			var joinTitleResize = $('#join h2').outerHeight(true);
			var joinSTResize = joinPaddingResize + joinTitleResize;
			if ($(window).width() > 992) {
				$('#join_highlight').css('top',joinSTResize);
			}
		});

		$('#markets_selector a').mouseover(function() {
			var $slide = $(this).data('slide');
			$('#market_slider').slick('slickGoTo',$slide);
		});

		$('#market_slider').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			dots: false,
			arrows: false,
			fade: true,
			speed: 500,
			cssEase: 'linear',
			autoplay: false,
			draggable: false,
		});

		$('#testimonials_slider').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			dots: false,
			arrows: true,
			fade: true,
			speed: 500,
			cssEase: 'linear',
			autoplay: false,
			prevArrow: $('#test_prev'),
			nextArrow: $('#test_next')
		});

		$('#latest_posts_slider').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			dots: false,
			arrows: true,
			fade: false,
			speed: 500,
			infinite: false,
			slidesPerRow: 1,
			cssEase: 'linear',
			autoplay: false,
			vertical: true,
			prevArrow: $('.post_prev'),
			nextArrow: $('.post_next'),
			responsive: [
			    {
			      	breakpoint: 993,
			      	settings: {
			        	vertical: false,
			      	}
			    },
		    ],
		});
	};

	var jobSearchHeight = $('#job_search_float .card').height();
	$('#join_team .card').height(jobSearchHeight);

	$(window).on('resize', function () {
		var jobSearchHeightResize = $('#job_search_float .card').height();
		$('#join_team .card').height(jobSearchHeightResize);
	});

	$('#job_search_trigger a').click(function(event) {
		event.preventDefault();
		$('#job_search_float').addClass('show');
		$('#job_search_fixed').addClass('show');
		$('#job_search_trigger').addClass('hide');
	});

	$('#job_search_trigger_mobile a').click(function(event) {
		event.preventDefault();
		$('#job_search_mobile').addClass('show');
		$('#job_search_trigger_mobile').addClass('hide');
	});

	$('.close_mobile_search').click(function(event) {
		event.preventDefault();
		$('#job_search_mobile').removeClass('show');
		$('#job_search_trigger_mobile').removeClass('hide');
	});

	if ($('#header').length > 0) {

	    var header = $('#header').offset().top;
		var headerHeight = $('#header').outerHeight(true);
		var headerCombined = header + headerHeight - 100;

	};

    $(window).scroll(function() {

    	var scroll = $(window).scrollTop();


				
		if (scroll >= (headerCombined)){ 
			$('.join_cta_home').addClass('hide');
			$('#job_search_fixed').addClass('fixed');
			$('#job_search_float').addClass('hide');
		} else {
			$('.join_cta_home').removeClass('hide');
			$('#job_search_fixed').removeClass('fixed');
			$('#job_search_float').removeClass('hide');
		}

	});

    $('.float_close').click(function(event) {
    	event.preventDefault();
    	$('#job_search_float').removeClass('show');
		$('#job_search_fixed').removeClass('show');
		$('#job_search_trigger').removeClass('hide');
    });

	if ($('.page-template-form').length > 0) { 

		if ($(window).width() > 992) {
			$('#field_1_5').matchHeight({
				target: $('#field_1_8'),
			});
		}
	};

	$('select[name="market"').select2({
		minimumResultsForSearch: Infinity,
    	allowClear: false,
    	width: '100%',
    	placeholder: 'Market',
	});

	$('select[name="continent"').select2({
		minimumResultsForSearch: Infinity,
    	allowClear: false,
    	width: '100%',
    	placeholder: 'Continent',
	});

	$('select[name="sort_posts"').select2({
		minimumResultsForSearch: Infinity,
    	allowClear: false,
    	width: '100%',
    	placeholder: 'Sort results by:',
	});

	$('select[name="archive-dropdown"').select2({
		minimumResultsForSearch: Infinity,
    	allowClear: false,
    	width: '100%',
    	placeholder: 'Archive',
	});

	$('select[name="cat"').select2({
		minimumResultsForSearch: Infinity,
    	allowClear: false,
    	width: '100%',
    	placeholder: 'Tags',
	});

	if ($('.page-template-history').length > 0) {
		if ($(window).width() > 992) {
			new WOW().init();
		};
		if ($(window).width() > 992) {
			var headerPaddingBottom = parseInt($('#header').css('margin-bottom'));
			$('#header').css('padding-top',mainNavHeight);
			//$('#header').css('height','calc(100vh - ' + headerPaddingBottom + 'px)');
			$(window).on('resize', function () {
				var headerPaddingBottomResize = parseInt($('#header').css('margin-bottom'));
				$('#header').css('padding-top',mainNavHeight);
				//$('#header').css('height','calc(100vh - ' + headerPaddingBottomResize + 'px)');
			});
		};
		if ($(window).width() < 991) {
			var mobileNavHeight = parseInt($('#mobile_nav').outerHeight(true));
			var mobileHeight = mainNavHeight + mobileNavHeight;
			$('#header').css('padding-top',mobileHeight);
		}
	};

	if ($('.page-template-global_reach').length > 0) {
		if ($(window).width() > 992) {
			new WOW().init();
		};
		if ($(window).width() > 992) {
			var headerPaddingBottom = parseInt($('#header').css('margin-bottom'));
			$('#header').css('padding-top',mainNavHeight);
			//$('#header').css('height','calc(100vh - ' + headerPaddingBottom + 'px)');
			$(window).on('resize', function () {
				var headerPaddingBottomResize = parseInt($('#header').css('margin-bottom'));
				$('#header').css('padding-top',mainNavHeight);
				//$('#header').css('height','calc(100vh - ' + headerPaddingBottomResize + 'px)');
			});
		};
		if ($(window).width() < 991) {
			var mobileNavHeight = parseInt($('#mobile_nav').outerHeight(true));
			var mobileHeight = mainNavHeight + mobileNavHeight;
			$('#header').css('padding-top',mobileHeight);
		}
	};

	if ($('.page-template-executive_candidates').length > 0) {
		if ($(window).width() > 992) {
			new WOW().init();
		};
		if ($(window).width() > 992) {
			var headerPaddingBottom = parseInt($('#header').css('margin-bottom'));
			$('#header').css('padding-top',mainNavHeight);
			$('#header').css('height','calc(100vh - ' + headerPaddingBottom + 'px)');
			$('#header .card').css('height','calc(100vh - ' + headerPaddingBottom + 'px - ' + mainNavHeight + 'px)');
			$('#header .card-img').css('height','calc(100vh - ' + headerPaddingBottom + 'px - ' + mainNavHeight + 'px)');
			$(window).on('resize', function () {
				var headerPaddingBottomResize = parseInt($('#header').css('margin-bottom'));
				$('#header').css('padding-top',mainNavHeight);
				$('#header').css('height','calc(100vh - ' + headerPaddingBottomResize + 'px)');
				$('#header .card').css('height','calc(100vh - ' + headerPaddingBottomResize + 'px - ' + mainNavHeight + 'px)');
				$('#header .card-img').css('height','calc(100vh - ' + headerPaddingBottomResize + 'px - ' + mainNavHeight + 'px)');
			});
		};
		if ($(window).width() < 991) {
			var mobileNavHeight = parseInt($('#mobile_nav').outerHeight(true));
			var mobileHeight = mainNavHeight + mobileNavHeight;
			$('#header').css('padding-top',mobileHeight);
		}
		$('#testimonials_slider').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			dots: false,
			arrows: true,
			fade: true,
			speed: 500,
			cssEase: 'linear',
			autoplay: false,
			prevArrow: $('#test_prev'),
			nextArrow: $('#test_next')
		});
		$('#reasons_slider').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			dots: false,
			arrows: true,
			fade: true,
			speed: 500,
			cssEase: 'linear',
			autoplay: false,
			prevArrow: $('#reason_prev'),
			nextArrow: $('#reason_next'),
			asNavFor: '#reasons_slider_count',
		});
		$('#reasons_slider_count').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			dots: false,
			arrows: false,
			fade: true,
			speed: 500,
			cssEase: 'linear',
			autoplay: false,
			asNavFor: '#reasons_slider',
		});
		$('.dismiss').click(function(event) {
			event.preventDefault();
			$('#reasons_text').removeClass('show');
		});
	 	$('a[data-slide]').click(function(event) {
		   	event.preventDefault();
		   	var slideno = $(this).data('slide');
		   	$('#reasons_slider').slick('slickGoTo', slideno);
		   	$('a[data-slide]').not(this).removeClass('active');
		   	$(this).addClass('active');
		   	$('#reasons_text').addClass('show');
	 	});
	 	$('#reasons_slider').on('afterChange', function(event, slick, currentSlide, nextSlide){
	 		var currentSlide = $('#reasons_slider').slick('slickCurrentSlide');
		  	var hotspot = '.hotspot_' + currentSlide;
		  	$('a[data-slide]').removeClass('active');
		  	$(hotspot).find('a').addClass('active');
		});
	};

	if ($('.page-template-market_focus').length > 0) {
		if ($(window).width() > 992) {
			new WOW().init();
		};
		if ($(window).width() > 992) {
			$('#header').css('padding-top',mainNavHeight);
			$(window).on('resize', function () {
				$('#header').css('padding-top',mainNavHeight);
			});
		};
		if ($(window).width() < 991) {
			var mobileNavHeight = parseInt($('#mobile_nav').outerHeight(true));
			var mobileHeight = mainNavHeight + mobileNavHeight;
			$('#header').css('padding-top',mobileHeight);
		}
	};

	if ($('.page-template-team').length > 0) {
		$('#team_slider').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			dots: false,
			arrows: false,
			fade: true,
			speed: 1000,
			cssEase: 'linear',
			autoplay: true,
			draggable: false,
		});
		if ($(window).width() > 992) {
			new WOW().init();
			var headerPaddingBottom = parseInt($('#content').css('padding-bottom'));
			$('#header').css('padding-top',mainNavHeight);
			$(window).on('resize', function () {
				var headerPaddingBottomResize = parseInt($('#content').css('padding-bottom'));
				$('#header').css('padding-top',mainNavHeight);
			});
		};
		if ($(window).width() < 991) {
			var mobileNavHeight = parseInt($('#mobile_nav').outerHeight(true));
			var mobileHeight = mainNavHeight + mobileNavHeight;
			$('#header').css('padding-top',mobileHeight);
		}
	};

	if ($('.page-template-ethos').length > 0) {
		if ($(window).width() > 992) {
			new WOW().init();
		};
		if ($(window).width() > 992) {
			var headerPaddingBottom = parseInt($('#header').css('padding-bottom'));
			$('#header').css('padding-top',mainNavHeight);
			$('#header').css('height','100vh');
			//$('#header_image').css('height','calc(100vh - ' + headerPaddingBottom + 'px - ' + mainNavHeight + 'px)');
			//$('#lady_image img').css('height','calc(100vh - ' + headerPaddingBottom + 'px - ' + mainNavHeight + 'px)');
			//$('#header_image .card-img').css('height','calc(100vh - ' + headerPaddingBottom + 'px - ' + mainNavHeight + 'px)');
			$(window).on('resize', function () {
				var headerPaddingBottomResize = parseInt($('#header').css('padding-bottom'));
				$('#header').css('padding-top',mainNavHeight);
				$('#header').css('height','100vh');
				//$('#header').css('height','calc(100vh - ' + headerPaddingBottomResize + 'px)');
				//$('#header_image').css('height','calc(100vh - ' + headerPaddingBottomResize + 'px - ' + mainNavHeight + 'px)');
				//$('#header_image .card-img').css('height','calc(100vh - ' + headerPaddingBottomResize + 'px - ' + mainNavHeight + 'px)');
				//$('#lady_image img').css('height','calc(100vh - ' + headerPaddingBottomResize + 'px - ' + mainNavHeight + 'px)');
			});
			var peopleFirstTitle = $('#people_first .h2').outerHeight(true);
			$('#people_first_highlight').css('top',peopleFirstTitle);
		};
		if ($(window).width() < 991) {
			var mobileNavHeight = parseInt($('#mobile_nav').outerHeight(true));
			var mobileHeight = mainNavHeight + mobileNavHeight;
			$('#header').css('padding-top',mobileHeight);
		}
	};

	if ($('.single-team_member').length > 0) {
		if ($(window).width() > 992) {
			new WOW().init();
		};
		if ($(window).width() > 992) {
			$('#header').css('padding-top',mainNavHeight);
		};
		if ($(window).width() < 991) {
			var mobileNavHeight = parseInt($('#mobile_nav').outerHeight(true));
			var mobileHeight = mainNavHeight + mobileNavHeight;
			$('#header').css('padding-top',mobileHeight);
		}
	};


	if ($('.blog').length > 0) {
		if ($(window).width() > 992) {
			new WOW().init();
		};
		if ($(window).width() > 992) {
			$('#header').css('padding-top',mainNavHeight);
		};
		if ($(window).width() < 991) {
			var mobileNavHeight = parseInt($('#mobile_nav').outerHeight(true));
			var mobileHeight = mainNavHeight + mobileNavHeight;
			$('#header').css('padding-top',mobileHeight);
		}
	};

	if ($('.archive.date').length > 0) {
		if ($(window).width() > 992) {
			new WOW().init();
		};
		if ($(window).width() > 992) {
			$('#header').css('padding-top',mainNavHeight);
		};
		if ($(window).width() < 991) {
			var mobileNavHeight = parseInt($('#mobile_nav').outerHeight(true));
			var mobileHeight = mainNavHeight + mobileNavHeight;
			$('#header').css('padding-top',mobileHeight);
		}
	};

	if ($('.archive.category').length > 0) {
		if ($(window).width() > 992) {
			new WOW().init();
		};
		if ($(window).width() > 992) {
			$('#header').css('padding-top',mainNavHeight);
		};
		if ($(window).width() < 991) {
			var mobileNavHeight = parseInt($('#mobile_nav').outerHeight(true));
			var mobileHeight = mainNavHeight + mobileNavHeight;
			$('#header').css('padding-top',mobileHeight);
		}
	};

	if ($('.blog_results').length > 0) {
		if ($(window).width() > 992) {
			new WOW().init();
		};
		if ($(window).width() > 992) {
			$('#header').css('padding-top',mainNavHeight);
		};
		if ($(window).width() < 991) {
			var mobileNavHeight = parseInt($('#mobile_nav').outerHeight(true));
			var mobileHeight = mainNavHeight + mobileNavHeight;
			$('#header').css('padding-top',mobileHeight);
		}
	};

	if ($('.single-post').length > 0) {
		if ($(window).width() > 992) {
			new WOW().init();
		};
		if ($(window).width() > 992) {
			$('#header').css('padding-top',mainNavHeight);
		};
		if ($(window).width() < 991) {
			var mobileNavHeight = parseInt($('#mobile_nav').outerHeight(true));
			var mobileHeight = mainNavHeight + mobileNavHeight;
			$('#header').css('padding-top',mobileHeight);
		}
	};


	if ($('.page-template-contact').length > 0) {
		if ($(window).width() > 992) {
			new WOW().init();
		};
		if ($(window).width() > 992) {
			$('#content').css('padding-top',mainNavHeight);
		};
		if ($(window).width() < 991) {
			var mobileNavHeight = parseInt($('#mobile_nav').outerHeight(true));
			var mobileHeight = mainNavHeight + mobileNavHeight;
			$('#header').css('padding-top',mobileHeight);
		}
	};

	if ($('.page-template-thanks').length > 0) {
		if ($(window).width() > 992) {
			$('#content').css('padding-top',mainNavHeight);
		};
		if ($(window).width() < 991) {
			var mobileNavHeight = parseInt($('#mobile_nav').outerHeight(true));
			var mobileHeight = mainNavHeight + mobileNavHeight;
			$('#content').css('padding-top',mobileHeight);
		}
	};

	if ($('.error404').length > 0) {
		if ($(window).width() > 992) {
			$('#content').css('padding-top',mainNavHeight);
		};
		if ($(window).width() < 991) {
			var mobileNavHeight = parseInt($('#mobile_nav').outerHeight(true));
			var mobileHeight = mainNavHeight + mobileNavHeight;
			$('#content').css('padding-top',mobileHeight);
		}
	};


	if ($('.page-template-policy').length > 0) {
		if ($(window).width() > 992) {
			new WOW().init();
		};
		if ($(window).width() > 992) {
			$('#content').css('padding-top',mainNavHeight);
		};
		if ($(window).width() < 991) {
			var mobileNavHeight = parseInt($('#mobile_nav').outerHeight(true));
			var mobileHeight = mainNavHeight + mobileNavHeight;
			$('#content').css('padding-top',mobileHeight);
		}
	};

	if ($('.page-template-market_overview').length > 0) {
		if ($(window).width() > 992) {
			new WOW().init();
		};
		var headerPaddingBottom = parseInt($('#header').css('margin-bottom'));
		if ($(window).width() > 992) {
			$('#header').css('padding-top',mainNavHeight);
			$('#header').css('height','calc(100vh - ' + headerPaddingBottom + 'px)');
			$(window).on('resize', function () {
				var headerPaddingBottomResize = parseInt($('#header').css('margin-bottom'));
				$('#header').css('padding-top',mainNavHeight);
				$('#header').css('height','calc(100vh - ' + headerPaddingBottomResize + 'px)');
			});
		};
		if ($(window).width() < 991) {
			var mobileNavHeight = parseInt($('#mobile_nav').outerHeight(true));
			var mobileHeight = mainNavHeight + mobileNavHeight;
			$('#header').css('padding-top',mobileHeight);
		}
	};

	if ($('.page-template-join').length > 0) {

		if ($(window).width() > 992) {
			new WOW().init();
			$('#header').css('padding-top',mainNavHeight);
			$(window).on('resize', function () {
				var headerPaddingBottomResize = parseInt($('#header').css('margin-bottom'));
				$('#header').css('padding-top',mainNavHeight);
			});
		};
		if ($(window).width() < 991) {
			var mobileNavHeight = parseInt($('#mobile_nav').outerHeight(true));
			var mobileHeight = mainNavHeight + mobileNavHeight;
			$('#header').css('padding-top',mobileHeight);
		}
	};

	if ($('.results_wrapper').length > 0) {
		if ($(window).width() > 992) {
			new WOW().init();
		};
		if ($(window).width() > 992) {
			$('#job_search_float .col-lg-6').css('top',0).css('right',0);
		};
	};

	if ($('.job_details_wrapper').length > 0) {
		if ($(window).width() > 992) {
			$('#job_search_float .col-lg-6').css('top',0).css('right',0);
		};
	};

	if ($('.page-template-er_search').length > 0) {
		if ($(window).width() > 992) {
			new WOW().init();
		};
		if ($(window).width() > 992) {
			var what_is_height = $('#what_is').outerHeight(true);
			var benefits_height = $('#benefits').outerHeight(true);
			$('#retained_bg').height(what_is_height+benefits_height);
			$(window).on('resize', function () {
				var what_is_height_resize = $('#what_is').outerHeight(true);
				var benefits_height_resize = $('#benefits').outerHeight(true);
				$('#retained_bg').height(what_is_height_resize+benefits_height_resize);
			});
		};
	};
});